<template>

    <v-page-section padded>
        <template #title>Usage</template>
        <template #body>
            <v-stats :stats="stats"></v-stats>
        </template>
    </v-page-section>

</template>

<script>

import numeral from 'numeral';

export default {

    props: {
        company: {
            type: Object,
            required: true,
        },
    },

    computed: {

        stats() {
            let stats = [];
            stats.push({
                label: 'Customers',
                value: numeral(this.company.customers_count).format('0,0') + ' of ' + numeral(this.company.customers_limit).format('0,0'),
            });
            stats.push({
                label: 'Monthly Emails',
                value: numeral(this.company.monthly_email_count).format('0,0') + ' of ' + numeral(this.company.monthly_email_limit).format('0,0'),
            });
            return stats;
        },

    },

}

</script>